import styled from 'styled-components';

export const WarningMessageWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.orange3};
  background: ${({ theme }) => theme.colors.orange1};
`;

export const WarningMessageTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const WarningMessageDescription = styled.div`
  display: flex;
  padding-left: 32px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
